<template>
  <div class="app-content">
    <Navbar />
    <div class="">
      <div
        class="w-full flex flex-wrap justify-center items-center text-white"
        style="min-height: 70vh"
      >
        <div class="h-100 px-10 md:flex items-center">
          <div class="text-center md:text-left md:w-2/5 px-10 lg:px-32">
            <h1
              class="text-3xl md:text-4xl lg:text-4xl mb-5 md:mb-0 leading-none font-bold"
            >
              About SPYOWS
            </h1>
          </div>
          <div class="md:w-3/5">
          <b>SPY On Wall Street –</b> Profit like the Pros
            <div
              class="md:block text-center md:text-left md:text-md lg:text-lg font-medium w-full"
            >
              <p>
                Spy On Wall Street signal service is a unique stock option recommendation service that uses a proprietary and tested algorithm based on - technical, sentimental, fundamentals, and volatility to consistently generate options (Buy and Sell) signals that can make you greater than 10% return on your investment capital on a consistent basis. We scan over 4000 optionable stocks and provide you winners.
              </p>
              <p>
                Wall street insiders are known to have an edge on main street when it comes to stock and options trading. Over the years, it is possible to see what these experts do by using a combination of technical, sentimental, and fundamental indicators. 
              </p>
              <p>
                We have developed a unique and tested algorithm that combine 4 unique parameters (Technical, Sentimental, Fundamentals and Volatility) indicators to see what the “Big Boys” are doing. We have done all the hard work for you. All you need to do is simply act on our signals and place the trade with your current broker of choice. To use our service, you must have a brokerage account that is approved for options trading. (Buy Calls, Sell Calls, Buy Put, Sell, and option spread). We offer full refund if you do not make at least 10-30 % on our recommended trade.
              </p>
            </div>
            To get started,<router-link to="/subscribe" class="subscribe-link"> subscribe here.</router-link>
          </div>
        </div>
      </div>
    </div>

    <Footer>Who We Are</Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/layout/Nav.vue";
import Footer from "@/components/layout/Footer.vue";

export default {
  name: "About",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | About",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Navbar,
    Footer
  }
};
</script>
<style scoped>
p{
  margin: 10px 0 10px 0;
}
.subscribe-link{
  color: #15E68A
}
</style>